import { MtxButton, MtxIcon } from '@meilleurtaux/mtp-uikit-react';
import { useTranslation } from 'react-i18next';

import { STATUS, STATUS_ICON } from '@/enums/status';

import styles from './styles.module.css';

import type { JSX } from 'react';

type WithButton = {
  labelButton: string | JSX.Element;
  onClickButton: () => void;
};

type WithoutButton = {
  labelButton?: never;
  onClickButton?: never;
};

type AlertProps = {
  status: STATUS;
  showIcon?: boolean;
  title?: string;
  description?: string;
  onClose?: () => void;
} & (WithButton | WithoutButton);

const Alert = ({ status, title, description, labelButton, onClickButton, onClose, showIcon }: AlertProps) => {
  const icon = STATUS_ICON[status];
  const { t } = useTranslation();

  return (
    <div className={`${styles.alert} ${styles[status]}${showIcon ? ` ${styles.withIcon}` : ''}`}>
      {showIcon && (
        <div className={styles.alertIcon}>
          <MtxIcon name={icon} size={32} />
        </div>
      )}
      <div className={styles.alertText}>
        {title && (
          <div className={styles.alertTextTitle}>
            <p>{title}</p>
          </div>
        )}
        {description && (
          <div className={styles.alertTextDescription}>
            <p>{description}</p>
          </div>
        )}
      </div>
      {labelButton && (
        <div className={styles.alertActions}>
          <MtxButton variant="info" className={styles.alertButton} onClick={onClickButton}>
            {labelButton}
          </MtxButton>
        </div>
      )}
      {onClose && (
        <MtxButton className={styles.alertCloseButton} onClick={onClose} aria-label={t('common.close')}>
          <MtxIcon name="cross" size={24} />
        </MtxButton>
      )}
    </div>
  );
};

export default Alert;
